export default function findByClassName(className) {
    return document.querySelector(`.${className.replace(/ /g, '.')}`);
}


// WEBPACK FOOTER //
// ./src/ButterToast/helpers/find_by_classname/index.js